import { render } from "./ScreenTextsPink.vue?vue&type=template&id=c2949582&ts=true"
import script from "./ScreenTextsPink.vue?vue&type=script&lang=ts"
export * from "./ScreenTextsPink.vue?vue&type=script&lang=ts"

import exportComponent from "/Users/matejvehar/git/mvehar/pi-slidoos/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__